module.exports = __webpack_public_path__ + "img/06.883d5bcf.png";